"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClampDelta = exports.getFitScaleFactor = exports.hasRectOverflow = exports.getBoundsUnion = exports.getSafeZoneHeight = exports.getSafeZoneWidth = exports.getRectCenter = exports.getRectBottom = exports.getRectRight = void 0;
var SAFE_ZONE_EPSILON = 0.5;
var getRectRight = function (rect) { return rect.left + rect.width; };
exports.getRectRight = getRectRight;
var getRectBottom = function (rect) { return rect.top + rect.height; };
exports.getRectBottom = getRectBottom;
var getRectCenter = function (rect) { return ({
    x: rect.left + rect.width / 2,
    y: rect.top + rect.height / 2,
}); };
exports.getRectCenter = getRectCenter;
var getSafeZoneWidth = function (rect) { return rect.right - rect.left; };
exports.getSafeZoneWidth = getSafeZoneWidth;
var getSafeZoneHeight = function (rect) { return rect.bottom - rect.top; };
exports.getSafeZoneHeight = getSafeZoneHeight;
var getBoundsUnion = function (bounds) {
    if (!bounds.length) {
        return null;
    }
    var left = bounds[0].left;
    var top = bounds[0].top;
    var right = (0, exports.getRectRight)(bounds[0]);
    var bottom = (0, exports.getRectBottom)(bounds[0]);
    bounds.slice(1).forEach(function (bound) {
        left = Math.min(left, bound.left);
        top = Math.min(top, bound.top);
        right = Math.max(right, (0, exports.getRectRight)(bound));
        bottom = Math.max(bottom, (0, exports.getRectBottom)(bound));
    });
    return {
        left: left,
        top: top,
        width: right - left,
        height: bottom - top,
    };
};
exports.getBoundsUnion = getBoundsUnion;
var hasRectOverflow = function (bounds, safeZone) {
    return (bounds.left < safeZone.left - SAFE_ZONE_EPSILON ||
        bounds.top < safeZone.top - SAFE_ZONE_EPSILON ||
        (0, exports.getRectRight)(bounds) > safeZone.right + SAFE_ZONE_EPSILON ||
        (0, exports.getRectBottom)(bounds) > safeZone.bottom + SAFE_ZONE_EPSILON);
};
exports.hasRectOverflow = hasRectOverflow;
var getFitScaleFactor = function (bounds, safeZone) {
    var center = (0, exports.getRectCenter)(bounds);
    var contentLeft = center.x - bounds.left;
    var contentRight = (0, exports.getRectRight)(bounds) - center.x;
    var contentTop = center.y - bounds.top;
    var contentBottom = (0, exports.getRectBottom)(bounds) - center.y;
    var safeLeft = center.x - safeZone.left;
    var safeRight = safeZone.right - center.x;
    var safeTop = center.y - safeZone.top;
    var safeBottom = safeZone.bottom - center.y;
    var candidates = [1];
    if (contentLeft > 0) {
        candidates.push(safeLeft / contentLeft);
    }
    if (contentRight > 0) {
        candidates.push(safeRight / contentRight);
    }
    if (contentTop > 0) {
        candidates.push(safeTop / contentTop);
    }
    if (contentBottom > 0) {
        candidates.push(safeBottom / contentBottom);
    }
    var width = bounds.width || 1;
    var height = bounds.height || 1;
    candidates.push((0, exports.getSafeZoneWidth)(safeZone) / width);
    candidates.push((0, exports.getSafeZoneHeight)(safeZone) / height);
    var factor = Math.min.apply(Math, __spreadArray([], __read(candidates), false));
    if (!Number.isFinite(factor) || factor <= 0) {
        return 1;
    }
    return factor;
};
exports.getFitScaleFactor = getFitScaleFactor;
var getClampDelta = function (bounds, safeZone) {
    var safeWidth = (0, exports.getSafeZoneWidth)(safeZone);
    var safeHeight = (0, exports.getSafeZoneHeight)(safeZone);
    var right = (0, exports.getRectRight)(bounds);
    var bottom = (0, exports.getRectBottom)(bounds);
    var dx = 0;
    var dy = 0;
    if (bounds.width > safeWidth) {
        dx = safeZone.left + safeWidth / 2 - (bounds.left + bounds.width / 2);
    }
    else if (bounds.left < safeZone.left) {
        dx = safeZone.left - bounds.left;
    }
    else if (right > safeZone.right) {
        dx = safeZone.right - right;
    }
    if (bounds.height > safeHeight) {
        dy = safeZone.top + safeHeight / 2 - (bounds.top + bounds.height / 2);
    }
    else if (bounds.top < safeZone.top) {
        dy = safeZone.top - bounds.top;
    }
    else if (bottom > safeZone.bottom) {
        dy = safeZone.bottom - bottom;
    }
    return { dx: dx, dy: dy };
};
exports.getClampDelta = getClampDelta;
//# sourceMappingURL=safe-zone.js.map